// A ?redirect= value may be attacker-controlled (it arrives in the URL), so it
// is only followed when it is an internal path: one leading slash, not two —
// "//host" and "/\host" are protocol-relative URLs, and navigating to them
// would let a crafted login link bounce a signed-in user to another site.
export const safeInternalPath = (p) => (typeof p === 'string' && /^\/(?![/\\])/.test(p) ? p : null);
